import type { MonarchTestHook, MonarchTestResult } from "../../useMonarchTestResult";

export type TypingStateStrategy = "attributes" | "skills" | "querySuggestions";

export const DEFAULT_TYPING_STATE_STRATEGY: TypingStateStrategy = "skills";

export const DEFAULT_QUERY_SUGGESTIONS_INDEX = "searches";

// Define the possible variants for this experiment
export type ProductSearchVariant = "control" | "test";

// Define the data structure returned by the experiment
export interface ProductSearchData {
  enabled: boolean;
  featuredPrograms: string[];
  featuredCategories: {
    label: string;
    url: string;
  }[];
  typingStateStrategy?: TypingStateStrategy;
  querySuggestionsIndex?: string;
  trendingSectionHeader?: string;
  /** Non-negative integer; clamped to [0, categories.length] at render time. */
  mobileCategoryLimit?: number;
  learnerFavoritesSectionHeader?: string;
  noResultsHeader?: string;
  noResultsBullets?: string[];
  footerText?: string;
  footerUrl?: string;
  footerLinkText?: string;
}

// Define the complete test result type for this experiment
export type ProductSearchTestResult = MonarchTestResult<
  ProductSearchVariant,
  ProductSearchData
>;

// Define the hook type for this experiment
export type UseProductSearch = MonarchTestHook<
  ProductSearchVariant,
  ProductSearchData
>;
